/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Upload_ErrorInputs */

const en_doc_upload_error = /** @type {(inputs: Doc_Upload_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload failed`)
};

const pt_br2_doc_upload_error = /** @type {(inputs: Doc_Upload_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha no upload`)
};

/**
* | output |
* | --- |
* | "Upload failed" |
*
* @param {Doc_Upload_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_upload_error = /** @type {((inputs?: Doc_Upload_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Upload_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_upload_error(inputs)
	return pt_br2_doc_upload_error(inputs)
});